export default "__VITE_ASSET__BEHw9f4R__"